var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dui-scroll-available",class:{ 'enabled': _vm.isEnabled }},[(_vm.isEnabled)?_c('DuiIconDown',{staticClass:"icon-sm icon-white"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }